//#region src/components/Tree/TreeSkeleton/TreeSkeleton.module.css
var e = "_skeleton_2yt1p_1", t = "_container_2yt1p_7", n = {
	skeleton: e,
	container: t
};
//#endregion
export { t as container, n as default, e as skeleton };
